module.exports = __webpack_public_path__ + "static/media/1542318959689-1647354993 - Citizen Datasteward.05e91832.jpg";